import React from 'react'

export default function Contact() {
    return (
        <main className="bg-green-100 min-h-screen p-12">
        <section className="container mx-auto">
            <h1 className="text-5xl flex justify-center cursive">Contact Page</h1>
            <h2 className="text-lg text-gray-600 flex justify-center mb-12">Coming Soon!!</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
               
            </div>
        </section>
        
    </main>
    )
}
